import { useTranslation } from 'Modules/core/i18n';

import { Document } from '../../api';
import { useDocs } from '../../state/documents';
import { DocumentsCommonProps } from '../DocumentsCommon/types';


interface GeneralDocuments {
    documents: Document[];
}

export const formatGeneralDocuments = (documents: Document[] = []): GeneralDocuments => ({
    documents: documents.filter(el => !el.checklist),
});

export const useGeneralDocumentsProps = (): DocumentsCommonProps => {
    const { t } = useTranslation('documents');

    const {
        data: { documents },
        isLoading: documentsLoading,
    } = useDocs('general', formatGeneralDocuments);

    return {
        title: t('generalDocuments') as string,
        showLoader: documentsLoading,
        documents: [
            {
                files: documents,
            },
        ],
    };
};
